import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import FeaturedApp from "@/components/site/FeaturedApp";
import Portfolio from "@/components/site/Portfolio";
import About from "@/components/site/About";
import Footer from "@/components/site/Footer";
import { useContent } from "@/contexts/ContentContext";

export default function PlayFoxLanding() {
  const { content } = useContent();
  return (
    <div className="min-h-screen bg-[hsl(var(--background))] text-[hsl(var(--foreground))]">
      <Nav />
      <main>
        <Hero content={content.hero} />
        <FeaturedApp content={content.featured} />
        <Portfolio content={content.portfolio} />
        <About content={content.about} />
      </main>
      <Footer content={content.footer} />
    </div>
  );
}
